<!--
  - Copyright (c) 2008-2020 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
  - This is CONFIDENTIAL code. Use is subject to license terms.
  -->
<template>
  <div class="has-float-label">
    <input
      :id="id"
      class="bg-transparent w-100"
      :class="[{ disabled: disabled }, { invalid: invalid }, inputClass]"
      :type="type"
      :placeholder="placeholder"
      :value="
        type === 'number'
          ? value
          : encoding === 'simple'
          ? $he.decode(value)
          : encoding === 'full'
          ? decode(value)
          : value
      "
      :autofocus="focus"
      :autocomplete="autocomplete"
      :readonly="readonly"
      :disabled="disabled"
      @keydown="$emit('keydown', $event)"
      @blur="$emit('blur', $event)"
      @input="encodeInput($event.target.value)"
      :min="type === 'number' && min !== null ? min : null"
      :max="type === 'number' && max !== null ? max : null"
    />
    <!-- Unset bootstrap's default label margin-bottom -->
    <label v-if="label" :for="id" class="label mb-0" :class="{ disabled: disabled, 'text-danger': invalid }">
      <span v-html="label"></span>
      <slot></slot>
    </label>
    <div class="sub-input"><slot name="sub-input"></slot></div>
  </div>
</template>

<script>
import StringHelpersMixin from "@/components/StringHelpersMixin"

export default {
  name: "text-input",

  props: {
    id: "",
    type: { type: String, default: "text" },
    value: { type: [String, Number], default: "" },
    label: { type: String, default: null },
    focus: false,
    autocomplete: null,
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    invalid: false,
    placeholder: { type: String, default: " " },
    custom: { type: String, default: "" },
    encoding: { type: String, default: "full" },
    inputClass: { type: String },
    min: { type: Number, default: null },
    max: { type: Number, default: null },
  },

  mixins: [StringHelpersMixin],

  mounted: function () {
    // To ensure encoding is applied on load, regardless of user input
    // Decode first to ensure various default encoding is removed before encoding.
    // Do not apply initial encode/decode if the encoding is set to none
    if (this.type !== "number" && this.encoding !== "none") {
      this.encodeInput(this.value)
    }
  },

  methods: {
    isValid() {
      return this.$refs[this.id] && this.$refs[this.id].classList.contains("is-valid")
    },

    encodeInput(val) {
      if (this.type === "number") {
        this.$emit("input", val)
      } else if (this.encoding === "simple") {
        this.$emit("input", this.$he.encode(this.$he.decode(val)))
      } else if (this.encoding === "full") {
        this.$emit("input", this.encode(this.decode(val), this.custom))
      } else {
        this.$emit("input", val)
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";
@import "@/assets/scss_custom/custom-variables.scss";

.disabled {
  color: $brand-gray;

  &:focus {
    border-color: $brand-gray;
  }
}

.invalid {
  border-color: $danger !important;
}

.label {
  margin-left: 0.125em;
}

.disable-scroll {
  appearance: textfield;
}

.sub-input {
  margin-left: 0.125em;
  font-size: 0.6em;
}
</style>
